<div class="loader relative h-full w-full">
  <div class="spinner"></div>
</div>
